export default __webpack_public_path__ + "static/media/combined.77c04cdf.png";